export default {
	methods: {
		showCompleteIdCheckModal() {
			if (!this.detect.device.isMobile) {
				return this.$vmodal.open({
					component: require("../modals/CompleteIdCheck.vue").default,
				});
			}

			window.open(this.$authed().idCheck.link);
		}
	}
};
